export default __webpack_public_path__ + "static/media/clairefontaine9.f60e585c.jpg";